import React, { useEffect, useState } from "react";
import "../styles/BottomNav.css";

import {
   FaHome,
  FaStore,
  FaRegCompass,
  FaBoxOpen,
  FaNewspaper,
  FaShoppingCart,
  FaBars,
  FaBoxes,
} from "react-icons/fa";

import { MdPostAdd } from "react-icons/md";
import { HiOutlineBookOpen } from "react-icons/hi2";

import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";

import {
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";



export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useAuth();

const [notificationCount, setNotificationCount] = useState(0);

  const { cart } = useCart();

  useEffect(() => {
  if (!user) return;

  const q = query(
    collection(db, "activity"),
    where("uid", "==", user.uid),
    where("read", "==", false)
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    setNotificationCount(snapshot.size);
  });

  return unsubscribe;

}, [user]);

  const cartCount = cart.reduce((sum, item) => sum + item.qty, 0);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bottom-nav">

{/* Home */}
<div
  className={`nav-item ${isActive("/") ? "active" : ""}`}
  onClick={() => navigate("/")}
>
  <FaHome className="nav-icon" />
  <span>Home</span>
</div>

{/* For You */}
<div
  className={`nav-item ${isActive("/foryou") ? "active" : ""}`}
  onClick={() => navigate("/foryou")}
  style={{ position: "relative" }}
>

  <FaRegCompass className="nav-icon" />

  {notificationCount > 0 && (
    <span className="notification-badge">
      {notificationCount > 99 ? "99+" : notificationCount}
    </span>
  )}

  <span>For You</span>

</div>

      {/* Local Updates 
      <div
        className={`nav-item ${isActive("/localupdates") ? "active" : ""}`}
        onClick={() => navigate("/localupdates")}
      >
        <FaNewspaper className="nav-icon" />
        <span>Updates</span>
      </div>

      */}

      {/* Info exchange 
<div
  className={`nav-item ${isActive("/ie") ? "active" : ""}`}
  onClick={() => navigate("/ie")}
>
  <HiOutlineBookOpen className="nav-icon" />
  <span>Info</span>
</div>
*/}

      {/* Posts */}
      <div
        className={`nav-item ${isActive("/posts") ? "active" : ""}`}
        onClick={() => navigate("/posts")}
      >
        <MdPostAdd className="nav-icon" />
        <span>Posts</span>
      </div>

      {/* Products 
      <div
        className={`nav-item ${isActive("/products") ? "active" : ""}`}
        onClick={() => navigate("/products")}
      >
        <FaBoxOpen className="nav-icon" />
        <span>Products</span>
      </div>

      */}

      {/* Shop Products */}
<div
  className={`nav-item ${isActive("/products") ? "active" : ""}`}
  onClick={() => navigate("/allproducts")}
>
  <FaBoxes className="nav-icon" />
  <span>
  Products
</span>
</div>

      {/* Shops 
      <div
        className={`nav-item ${isActive("/shops") ? "active" : ""}`}
        onClick={() => navigate("/shops")}
      >
        <FaStore className="nav-icon" />
        <span>Shops</span>
      </div>
*/}
      {/* Cart */}
      <div
        className={`nav-item ${isActive("/cart") ? "active" : ""}`}
        onClick={() => navigate("/cart")}
        style={{ position: "relative" }}
      >
        <FaShoppingCart className="nav-icon" />

        {cartCount > 0 && (
          <span className="cart-badge">
            {cartCount > 99 ? "99+" : cartCount}
          </span>
        )}

        <span>Cart</span>
      </div>

      {/* Menu */}
       <div
  className={`nav-item ${isActive("/more") ? "active" : ""}`}
  onClick={() => navigate("/more")}
>
  <FaBars className="nav-icon" />
  <span>Menu</span>
</div>


    </nav>
  );
}